/*
 * Silk Romance - Recently Viewed Products (Next-Phase, section 6)
 * Lightweight, client-side only. Stores up to 8 handles in localStorage,
 * shows the most recent 3 (excluding the current product) wherever
 * <sr-recently-viewed> is rendered. Reuses window.SREvents for tracking -
 * no parallel analytics system.
 */
(function () {
  'use strict';
  var KEY = 'sr_recently_viewed_v1';
  var MAX_STORED = 8;
  var MAX_SHOWN = 3;

  function readList() {
    try {
      var raw = window.localStorage.getItem(KEY);
      var list = raw ? JSON.parse(raw) : [];
      return Array.isArray(list) ? list : [];
    } catch (e) { return []; }
  }

  function writeList(list) {
    try { window.localStorage.setItem(KEY, JSON.stringify(list.slice(0, MAX_STORED))); } catch (e) {}
  }

  function recordView(handle, title, image, price, url) {
    if (!handle) return;
    var list = readList().filter(function (p) { return p.handle !== handle; });
    list.unshift({ handle: handle, title: title, image: image, price: price, url: url, ts: Date.now() });
    writeList(list);
  }

  function render(currentHandle) {
    var mounts = document.querySelectorAll('sr-recently-viewed');
    if (!mounts.length) return;

    var list = readList().filter(function (p) { return p.handle !== currentHandle; }).slice(0, MAX_SHOWN);
    if (!list.length) { mounts.forEach(function (m) { m.hidden = true; }); return; }

    var html = '<p class="sr-rv-heading">Recently Viewed</p><div class="sr-rv-grid">' + list.map(function (p) {
      return '<a class="sr-rv-card" href="' + p.url + '" data-sr-rv-handle="' + p.handle + '">' +
        '<img src="' + p.image + '" alt="' + (p.title || '').replace(/"/g, '') + '" loading="lazy" width="120" height="160">' +
        '<span class="sr-rv-title">' + p.title + '</span>' +
        (p.price ? '<span class="sr-rv-price">' + p.price + '</span>' : '') +
        '</a>';
    }).join('') + '</div>';

    mounts.forEach(function (mount) {
      mount.hidden = false;
      mount.innerHTML = html;
    });

    if (window.SREvents) {
      window.SREvents.track('recently_viewed_shown', { count: list.length });
    }

    document.querySelectorAll('[data-sr-rv-handle]').forEach(function (el) {
      el.addEventListener('click', function () {
        if (window.SREvents) {
          window.SREvents.track('recently_viewed_clicked', { handle: el.getAttribute('data-sr-rv-handle') });
        }
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    var pageData = document.getElementById('sr-current-product-data');
    var current = null;
    if (pageData) {
      try {
        current = JSON.parse(pageData.textContent);
        recordView(current.handle, current.title, current.image, current.price, current.url);
      } catch (e) {}
    }
    render(current ? current.handle : null);
  });
})();
